import { render, staticRenderFns } from "./change-dietitian.page.vue?vue&type=template&id=01a6e1f2&"
import script from "./change-dietitian.page.vue?vue&type=script&lang=js&"
export * from "./change-dietitian.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports